import { passkeyQueryKeys as e } from "./usePasskeyQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { usersApi as r } from "@maat/api-main";
//#region src/passkeys/useCompletePasskeyEnrollmentMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.completePasskeyEnrollment,
		retry: !1,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCompletePasskeyEnrollmentMutation };
